import { baseApi } from './baseApi';

// The Today's Tasks board: staff-defined columns (saved queries) evaluated against one anchor date.
export const taskColumnsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // The rule-kind catalogue. The column builder renders its inputs from the parameter schemas
    // returned here, so a new rule kind added on the server needs no change in this app.
    ruleKinds: build.query({
      query: () => '/task-columns/kinds',
      transformResponse: (resp) => resp.data,
      providesTags: ['RuleKind'],
    }),
    columnBoard: build.query({
      query: ({ anchor, rowsPerColumn = 25 } = {}) => {
        const p = new URLSearchParams();
        if (anchor) p.append('anchor', anchor);
        p.append('rowsPerColumn', rowsPerColumn);
        return `/task-columns/board?${p.toString()}`;
      },
      transformResponse: (resp) => resp.data,
      // Every column reads live CRM data, so the board refetches when any of it moves.
      providesTags: [
        'TaskColumn', 'ClinicTask',
        { type: 'Lead', id: 'LIST' }, { type: 'LeadFollowUp', id: 'LIST' },
        { type: 'Patient', id: 'LIST' }, { type: 'Appointment', id: 'LIST' }, { type: 'Invoice', id: 'LIST' },
      ],
    }),
    columnMatches: build.query({
      query: ({ id, anchor, page = 1, pageSize = 50 }) => {
        const p = new URLSearchParams();
        if (anchor) p.append('anchor', anchor);
        p.append('page', page);
        p.append('pageSize', pageSize);
        return `/task-columns/${id}/matches?${p.toString()}`;
      },
      transformResponse: (resp) => resp.data,
      providesTags: ['TaskColumn'],
    }),
    createColumn: build.mutation({
      query: (body) => ({ url: '/task-columns', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['TaskColumn'],
    }),
    updateColumn: build.mutation({
      query: ({ id, ...body }) => ({ url: `/task-columns/${id}`, method: 'PUT', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['TaskColumn'],
    }),
    deleteColumn: build.mutation({
      query: (id) => ({ url: `/task-columns/${id}`, method: 'DELETE' }),
      invalidatesTags: ['TaskColumn'],
    }),
    reorderColumns: build.mutation({
      query: (orderedIds) => ({ url: '/task-columns/reorder', method: 'POST', body: { orderedIds } }),
      invalidatesTags: ['TaskColumn'],
    }),
    dismissMatches: build.mutation({
      query: (body) => ({ url: '/task-columns/dismiss', method: 'POST', body }),
      invalidatesTags: ['TaskColumn'],
    }),
    restoreMatches: build.mutation({
      query: (body) => ({ url: '/task-columns/restore', method: 'POST', body }),
      invalidatesTags: ['TaskColumn'],
    }),
  }),
});

export const {
  useRuleKindsQuery,
  useColumnBoardQuery,
  useColumnMatchesQuery,
  useCreateColumnMutation,
  useUpdateColumnMutation,
  useDeleteColumnMutation,
  useReorderColumnsMutation,
  useDismissMatchesMutation,
  useRestoreMatchesMutation,
} = taskColumnsApi;
